<template>
	<view @click="click(data.config.path)" style="overflow: hidden;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">

		<view
			style="display:flex;height:80rpx;align-items:center;justify-content: center;padding-left:30rpx; padding-right:30rpx;"
			@click="click">
			<view style="font-size:28rpx;flex:1">商品订单</view>
			<view style="font-size:24rpx;" class="t-box">查看全部订单
				<uni-icons type="right" size="16"></uni-icons>
			</view>
		</view>
		<view class="groupCat_item_container"
			:style="{ background: data.config.containerBgColor, color: data.config.textColor }">
			<view class="small_menuItem_view" v-for="(item, index) in order" :key="index"
				:data-order-status="item.status" @click="click">
				<view style="display: flex; align-items: center;">
					<uni-icons :type="item.icon" size="26" :color="data.config.iconColor"></uni-icons>
					<uni-badge :text="item.count" type="error" size="small"></uni-badge>
				</view>

				<!-- <uni-badge text="3" type="primary" :inverted="true"></uni-badge>
				<uni-badge text="2" type="purple">
					<uni-icons type="contact" size="40" :color="data.config.iconColor"></uni-icons>
				</uni-badge> -->
				<text style="font-size: 14px;" class="menuItem-label" :style="{ color: data.config.textColor }">{{ item.title }}</text>
			</view>
		</view>


	</view>
</template>

<script>
	export default {
		name: 'Tpl_Text',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
			order: {
				type: Array,
				default: () => []
			},
		},
		data() {
			return {
				
			}
		},
		methods: {
			click() {
				uni.navigateTo({
					url: '/pages/mall/order_list'
				});

			},
		}
	};
</script>

<style scoped>
	.t-box {
		display: flex;
		align-items: center;
	}

	.groupCat_item_container {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		padding: 5px;
	}

	.small_menuItem_view {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 2px;
		padding: 2px;
	}

	.menuItem-label {
		font-size: 16px;
		margin-top: 2px;
	}
</style>